const projectRequestsPanel = {
  title: "Your requests in this project",
  newRequest: "New request",
  empty: "You haven't submitted any requests in this project yet.",
  type: {
    data: "Data request",
    access: "Access request",
  },
  viewAll: "View all your requests →",
};

export default projectRequestsPanel;
